import { ActionError, CreateOrderResponse } from '@dgx-pr-spa/shared/util';
import { createAction, props } from '@ngrx/store';

export const loadCreateOrder = createAction(
  '[Complete Order] Load Create Order',
  props<{ payload: { showFullLoader: boolean } }>()
);

export const cacheOrderSuccess = createAction(
  '[Complete Order] Load Create Success'
);
export const submitOrderSuccess = createAction(
  '[Complete Order] Submit Create Success'
);

export const cacheOrder = createAction('[Complete Order] Cache Order');
export const submitOrder = createAction('[Complete Order] Submit Order');

export const loadCreateOrderSuccess = createAction(
  '[Complete Order] Load Create Order Success',
  props<{ payload: CreateOrderResponse }>()
);

export const loadCreateOrderFail = createAction(
  '[Complete Order] Load Create Order Fail',
  props<{ payload: ActionError }>()
);

export const resetCreateOrder = createAction(
  '[Complete Order] Reset Create Order'
);

export type CreateOrderActions =
  | typeof loadCreateOrder
  | typeof loadCreateOrderSuccess
  | typeof loadCreateOrderFail
  | typeof resetCreateOrder
  | typeof cacheOrder
  | typeof cacheOrderSuccess
  | typeof submitOrder
  | typeof submitOrderSuccess;
